var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipseSmright({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 488,
    viewBox: "0 0 334 488",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_14368_32155)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 311.5,
    cy: 323,
    rx: 123.5,
    ry: 135,
    fill: "#6640CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_14368_32155",
    x: 0,
    y: 0,
    width: 623,
    height: 646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 94,
    result: "effect1_foregroundBlur_14368_32155"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipseSmright);
export default __webpack_public_path__ + "static/media/EllipseSmright.aa1e6e98b652222d29ec9747a5e9619c.svg";
export { ForwardRef as ReactComponent };